import { all, takeLatest } from "redux-saga/effects";
import processAction from "../../../../utils/processAction";
import { actionType as productActionTypes } from "./reducer";
import {
  getProducts as getProductsService,
  getAllProducts as getAllProductsService,
  createProduct as createProductService,
  updateProduct as updateProductService,
  deleteProduct as deleteProductService
} from "./service";

function* getProducts({ id, params }) {
  yield processAction({
    params: { id, params },
    service: getProductsService,
    success: productActionTypes.GET_PRODUCTS_SUCCESS,
    failed: productActionTypes.GET_PRODUCTS_FAILED
  })
}

function* getAllProducts({ id, params }) {
  yield processAction({
    params: { id, params },
    service: getAllProductsService,
    success: productActionTypes.GET_ALL_PRODUCTS_SUCCESS,
    failed: productActionTypes.GET_ALL_PRODUCTS_FAILED
  })
}

function* createProduct({ company_id, body }) {
  yield processAction({
    params: { company_id, body },
    service: createProductService,
    success: productActionTypes.CREATE_PRODUCT_SUCCESS,
    failed: productActionTypes.CREATE_PRODUCT_FAILED
  })
}

function* updateProduct({ company_id, product_id, body }) {
  yield processAction({
    params: { company_id, product_id, body },
    service: updateProductService,
    success: productActionTypes.UPDATE_PRODUCT_SUCCESS,
    failed: productActionTypes.UPDATE_PRODUCT_FAILED
  })
}

function* deleteProduct({ company_id, product_id }) {
  yield processAction({
    params: { company_id, product_id },
    service: deleteProductService,
    success: productActionTypes.DELETE_PRODUCT_SUCCESS,
    failed: productActionTypes.DELETE_PRODUCT_FAILED
  })
}


function* watchProducts() {
  yield all([
    takeLatest(productActionTypes.GET_PRODUCTS, getProducts),
    takeLatest(productActionTypes.GET_ALL_PRODUCTS, getAllProducts),
    takeLatest(productActionTypes.CREATE_PRODUCT, createProduct),
    takeLatest(productActionTypes.UPDATE_PRODUCT, updateProduct),
    takeLatest(productActionTypes.DELETE_PRODUCT, deleteProduct)
  ])
}

export default [watchProducts()];




// WEBPACK FOOTER //
// ./src/modules/company/pages/product/saga.js